import React from 'react'
import styles from './AnalyticsTable.module.scss'

interface AnalyticsTableRow {
  label: string
  visitors: number
  views: number
}

interface AnalyticsTableProps {
  title: string
  rows: AnalyticsTableRow[]
  labelHeader?: string
  icon?: React.ReactNode
  className?: never
}

export const AnalyticsTable: React.FC<AnalyticsTableProps> = ({
  title,
  rows,
  labelHeader = 'Name',
  icon,
}) => {
  const maxVisitors = Math.max(...rows.map((r) => r.visitors), 1)

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th className={styles.headerCell}>
            {icon && <span className={styles.headerIcon}>{icon}</span>}
            {labelHeader}
          </th>
          <th className={[styles.headerCell, styles.headerRight].join(' ')}>Visitors</th>
          <th className={[styles.headerCell, styles.headerRight].join(' ')}>Views</th>
        </tr>
      </thead>
      <tbody>
        {rows.length === 0 ? (
          <tr>
            <td colSpan={3} className={styles.empty}>
              No data for this period
            </td>
          </tr>
        ) : (
          rows.map((row, i) => {
            const pct = (row.visitors / maxVisitors) * 100
            return (
              <tr key={i} className={styles.row}>
                <td className={styles.cell}>
                  <span className={styles.labelRow}>
                    <span className={styles.label}>{row.label}</span>
                    <span className={styles.barTrack}>
                      <span className={styles.barFill} style={{ width: `${pct}%` }} />
                    </span>
                  </span>
                </td>
                <td className={[styles.cell, styles.cellRight].join(' ')}>
                  <span className={styles.numericValue}>{row.visitors.toLocaleString()}</span>
                </td>
                <td className={[styles.cell, styles.cellRight].join(' ')}>
                  <span className={styles.numericValue}>{row.views.toLocaleString()}</span>
                </td>
              </tr>
            )
          })
        )}
      </tbody>
    </table>
  )
}
